import h from 'react-hyperscript';

export default ({ size = 8, color: backgroundColor = '#7426c7', isRound = true, ...props } = {}) =>
  h('.loader.blink', {
    ...props,
    style: { backgroundColor, height: `${size}px`, width: `${size}px`, borderRadius: isRound ? `${size}px` : null },
  });



// WEBPACK FOOTER //
// ./src/components/Blink/Blink.js